export const microBrand = {
    product: 'rebels',
    accentMark: '#EC0E6E',
    accentMarkIdle: '#EC0E6E',
    markIdleOpacity: 0.2,
    twoToneIndicator: false,
    tint: '#FDE7F0',
    hover: '#FDECF3',
    focus: '#960041',
    text: '#161C24',
    destructive: '#B71D18',
    destructiveSoft: '#FFE4DE',
    destructiveStrong: '#7A100D',
    onDestructive: '#FFFFFF',
    sparkColors: ['#EC0E6E'],
    segmentStretch: 0.08,
    ambientTop: '#FFFFFF',
    ambientBottom: '#F4F6F8'
};
